<template>
  <Breadcrumb></Breadcrumb>
  <PurchaseAgreementForm :purchaseAgreement="purchaseAgreement" :title="$gettext('Nouveau compromis de vente')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { usePurchaseAgreementStore } from "@/stores/purchaseAgreement";
import { useRouter, useRoute } from "vue-router";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import PurchaseAgreementForm from "@/components/purchase-agreements/PurchaseAgreementForm.vue";

const router = useRouter();
const route = useRoute();
const saleListingAgreementId = route.query.saleListingAgreementId;
const purchaseOfferId = route.query.purchaseOfferId;

const purchaseAgreementStore = usePurchaseAgreementStore();
const purchaseAgreement = purchaseAgreementStore.empty;

const onSubmit = (payload, actions) => {
  purchaseAgreementStore.save(payload, saleListingAgreementId, purchaseOfferId, () => {
    router.push({ name: "sale-listing-agreement", params: { id: saleListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

</script>
